import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
	state : {
		sellers : {
			sellers : []
		}
	},
	getters : {},
	mutations : {
		fetchSellers (state, sellers) {

			state.sellers.sellers = sellers

		},
		updateSeller (state, seller) {

			state.sellers.sellers.find((element) => {

				if( element.id == seller.id ){

					element = seller

				}

			})

		}
	},
	actions : {
		fetchSellers (state, sellers) {

			state.sellers.sellers = sellers

		}
	}
})


// WEBPACK FOOTER //
// ./src/store.js